"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGasPrice = exports.GasPriceProvider = exports.PriceLevel = void 0;
var constate_1 = __importDefault(require("constate"));
var react_1 = require("react");
var web3_utils_1 = require("web3-utils");
var _shared_1 = require("../../shared");
var utils_1 = require("../../shared/utils");
var MULTIPLIER = 1.5;
var INTERVAL_MS = 60 * 1000;
var LEVELS = {
    ETH: [80, 100],
    BSC: [10, 15],
};
var PriceLevel;
(function (PriceLevel) {
    PriceLevel["low"] = "low";
    PriceLevel["medium"] = "medium";
    PriceLevel["high"] = "high";
})(PriceLevel = exports.PriceLevel || (exports.PriceLevel = {}));
function getPriceLevel(chain, price) {
    if (!LEVELS[chain])
        return PriceLevel.low;
    if (price < LEVELS[chain][0])
        return PriceLevel.low;
    if (price < LEVELS[chain][1])
        return PriceLevel.medium;
    return PriceLevel.high;
}
function useGasPriceRaw() {
    var _a = (0, _shared_1.useWeb3Provider)(), targetChainWeb3 = _a.targetChainWeb3, targetChain = _a.targetChain;
    var _b = (0, react_1.useState)(), gasPrice = _b[0], setGasPrice = _b[1];
    (0, react_1.useEffect)(function () {
        if (!targetChainWeb3)
            return;
        var fetch = function () {
            return targetChainWeb3.eth.getGasPrice().then(function (v) {
                var vBN = (0, web3_utils_1.toBN)(v);
                var multiplied = vBN.muln(MULTIPLIER).toString();
                (0, utils_1.debug)('gas price', v, 'multiplied', multiplied);
                setGasPrice(multiplied);
            });
        };
        // const id = setInterval(fetch, INTERVAL_MS);
        fetch();
        // return () => clearInterval(id);
    }, [targetChainWeb3]);
    return {
        gasPrice: gasPrice,
        level: gasPrice
            ? getPriceLevel(targetChain.symbol, parseInt((0, web3_utils_1.fromWei)(gasPrice, 'gwei')))
            : PriceLevel.low,
    };
}
var _a = (0, constate_1.default)(useGasPriceRaw), GasPriceProvider = _a[0], useGasPrice = _a[1];
exports.GasPriceProvider = GasPriceProvider;
exports.useGasPrice = useGasPrice;
